'use client';
import React from 'react';

interface Stat {
  value: string;
  label: string;
  color: string;
}

const stats: Stat[] = [
  { value: '600+', label: 'Free Channels', color: '#ffa300' },
  { value: '50+', label: 'Live TV Channels', color: '#00b9ff' },
  { value: '20+', label: 'Supported Devices', color: '#55cc35' },
  { value: '$4.99', label: 'Starting Per Day', color: '#ffa300' },
];

export default function StatsBar() {
  return (
    <section className="py-10 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="bg-[#20222f] border border-white/08 rounded-2xl px-6 py-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 divide-x-0 md:divide-x divide-white/10">
            {stats.map((stat, i) => (
              <div key={i} className="text-center px-4">
                <div
                  className="text-3xl sm:text-4xl font-black mb-1"
                  style={{ color: stat.color }}
                >
                  {stat.value}
                </div>
                <div className="text-[#979797] text-sm font-semibold">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
